module.exports = __webpack_public_path__ + "static/img/icon_2.4778784.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/icon_2.png
// module id = QOE+
// module chunks = 49